import React from 'react'
import { useState } from 'react';
import './Age.css'

const AGE_API = "https://api.agify.io"

const Age = () => {
    const [name, setName] = useState("")
    const [data, setData] = useState("")
    const [show, setShow] = useState(false)
    const [userName,setUserName]=useState("")

    const fetchData=()=>{
        fetch(`${AGE_API}?name=${name}`)
        .then(response => response.json())
        .then(json =>
            setData(json));
            setUserName(name)
            setShow(true)
            setName("")
    }

    const alert_name=()=>{
        return(
            alert("please enter your name to continue")
        )
    }

    const showData = (e) => {
        e.preventDefault()
        {name ? fetchData() : alert_name()}
       
    }

    const inputChange = (e) => {
        setName(e.target.value)
        setShow(false)
    }


    return (
        <div className="age">
            <form onSubmit={showData} >
                <span>Name</span><input type="text" value={name} onChange={inputChange} /><br />
                <button type="submit">Guess My Age</button>
            </form>
            <div className="results">
                {show ? <h2>hello {userName},I think, you are {data ? data.age : ""} years old and <span>there are currently more than {(data.count)*234} numbers of people named " {userName} " according to my knowledge who are of your age</span></h2> :<h2>The result will be displayed here </h2>
                
                }
            </div>
        </div>
    )
}

export default Age;
